/** Collateral quote for a Hyperliquid HIP-3 / main perp market row. */
export function quoteForMarket(m) {
  if (m?.quote) return m.quote;
  const d = String(m?.dex || 'main').toLowerCase();
  if (d === 'flx' || d === 'km') return 'USDH';
  return 'USDC';
}

export function displayMarketName(m) {
  if (!m?.symbol) return '—';
  return m.displayName || `${m.symbol}-${quoteForMarket(m)}`;
}

export function formatDexLabel(m) {
  return String(m?.dex || 'main').toLowerCase();
}

/** Free USDC on perps (tradable for Single Asset live). Spot USDC is excluded unless unified account. */
export function hlUsdcBalance(status) {
  if (!status) return null;
  const tradable = status.tradableUsdc ?? status.perpsUsdc ?? status.withdrawableUsdc ?? status.withdrawableUsd;
  if (tradable != null && Number(tradable) > 0) return Number(tradable);
  const free = status.perpsUsdc ?? status.withdrawableUsdc ?? status.withdrawableUsd;
  if (free != null && Number(free) > 0) return Number(free);
  // Equity fallback when margin is in use — never use displayUsdc (includes spot for legacy accounts).
  const equity = status.perpsEquityUsdc;
  if (equity != null && Number(equity) > 0) return Number(equity);
  if (status.unifiedAccount) {
    const spot = status.spotUsdc;
    if (spot != null && Number(spot) > 0) return Number(spot);
  }
  return free != null ? Number(free) : null;
}

/** Free USDC on Hyperliquid spot (not tradable for perps until moved). */
export function hlSpotUsdcBalance(status) {
  if (!status) return null;
  return status.spotUsdc ?? null;
}

/** Free SOL on Hyperliquid spot (before convert to USDC). */
export function hlSpotSolBalance(status) {
  if (!status) return null;
  return status.spotSol ?? null;
}

/** Hyperliquid USDH balance (flx / km tradfi). */
export function hlUsdhBalance(status) {
  if (!status) return null;
  const flx = status.withdrawableUsdhFlx;
  const km = status.withdrawableUsdhKm;
  if (flx == null && km == null) return null;
  if (flx != null && km != null) return Math.max(flx, km);
  return flx ?? km;
}

export function collateralBalanceForMarket(status, m) {
  if (!status || !m) return null;
  return quoteForMarket(m) === 'USDH' ? hlUsdhBalance(status) : hlUsdcBalance(status);
}
